import { Component, OnInit } from '@angular/core';
import { SenaceService } from 'src/app/services/senace.service';


import { ITipoEstudio, IDepartamento, IProvincia, IDistrito, IActividad, IEstado, IListado } from "src/app/interface/interfaces";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2'


import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { LocalStorage } from '@ngx-pwa/local-storage';
import { DatepicketLocalizationService } from 'src/app/services/datepicker.language.service';

const moment = require('moment');

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent extends DatepicketLocalizationService implements OnInit {
  dataTipoEstudio: ITipoEstudio[] = [];
  dataDepartamento: IDepartamento[] = [];
  dataProvincia: IProvincia[] = [];
  dataDistrito: IDistrito[] = [];
  dataActividad: IActividad[] = [];
  dataEstado: IEstado[] = [];
  resultado: IListado[] = [];

  currentPage = 1;
  itemsPerPage = 50;
  pageSize: number;

  formulario: FormGroup;

  fromDate: NgbDateStruct = null;
  toDate: NgbDateStruct = null;

  fechaDesde = '';
  fechaHasta = '';

  maxDate: NgbDate;

  seleccion: boolean;

  constructor(
    private serviceSenace: SenaceService,
    private formBuilder: FormBuilder,
    private router: Router,
    private localStorage: LocalStorage,

    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
  ) {
    super();
    this.iniciarFormulario();
    this.buscarRegistros();
  }
  ngOnInit() {
    this.getTipoEstudio();
    this.getDepartamento();
    this.getActividad();
    this.getEstado();
    this.maxDate = this.calendar.getToday();
  }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  changePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }

  iniciarFormulario() {
    this.formulario = this.formBuilder.group({
      titular: [''],
      ruc: ['', [Validators.pattern(/^[0-9]{11}$/)]],
      nroexpediente: ['', [Validators.pattern('^[a-zA-Z0-9-]+$'), Validators.maxLength(20)]],
      tipoestudio: [''],
      tituloproyecto: [''],
      unidadproyecto: [''],
      departamento: [0],
      provincia: [0],
      distrito: [0],
      actividad: [0],
      estado: [0],
      fechaDesde: [''],
      fechaHasta: [''],
      enAporte: [0]
    });
  }
  formatoFecha(fecha: NgbDate) {
    if (fecha) {
      return `${fecha.day}/${fecha.month}/${fecha.year}`;
    }
    return '';
  }
  buscarRegistros(tipo?: string) {
    Swal.fire({
      text: 'Espere por favor ...',
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: false
    });
    Swal.showLoading();
    if (tipo) {
      this.buscarAporteCiudadano();
    } else {
      this.buscarFormulario();
    }
  }
  buscarFormulario() {
    if (this.formulario.invalid) {
      Swal.fire({
        title: 'Aviso',
        text: 'Verifique los campos del formulario',
        icon: 'warning',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    if (!this.validarFechaBusqueda()) {
      return false;
    }
    this.formulario.patchValue({
      enAporte: 0 ,
      fechaDesde : this.fechaDesde,
      fechaHasta : this.fechaHasta
    });
    this.serviceSenace.postBuscarConsulta(this.formulario.value)
      .subscribe(
        (response) => {
          Swal.close();
          this.resultado = response;
        },
        (error) => {
          Swal.fire({
            title: `Código error: ${error.status}`,
            text: 'Error en la búsqueda. Intente nuevamente o actualice la página',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        }
      );
  }

  buscarAporteCiudadano() {
    this.fechaDesde = '';
    this.fechaHasta = '';

    this.formulario.patchValue({
      titular: '', ruc: '', nroexpediente: '', tipoestudio: '', tituloproyecto: '', unidadproyecto: '',
      departamento: 0, provincia: 0, distrito: 0, estado: 0, actividad: 0,
      fechaDesde: '',
      fechaHasta: '', 
      enAporte: 1
    });
    this.serviceSenace.postBuscarConsulta(this.formulario.value)
      .subscribe(
        (response) => {
          Swal.close();
          this.resultado = response;
        },
        (error) => {
          Swal.fire({
            title: 'Aviso',
            text: 'Error en la búsqueda. Intente nuevamente o actualice la página',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        }
      );
  }
  limpiar(): void {
    this.fromDate = null;
    this.toDate = null;
    this.fechaDesde = '';
    this.fechaHasta = '';
    this.formulario.patchValue({
      titular: '', ruc: '', nroexpediente: '', tipoestudio: '', tituloproyecto: '', unidadproyecto: '',
      departamento: 0, provincia: 0, distrito: 0, estado: 0, actividad: 0, 
      fechaDesde: '',
      fechaHasta: '',
      enAporte: 1
    });
  }
  leerDetalleExpediente(expediente: any, registrarAporte, url:string) {
    this.serviceSenace.getDetalleExpediente(expediente.expediente).subscribe(
      (respuesta) => {
        Swal.close();
        if (respuesta) {
          if (!respuesta.error) {
            console.log(expediente);

            respuesta['url'] = url;
            respuesta["proyectoId"] = expediente.idProyecto;
            respuesta["expedienteId"] = expediente.idExpediente;
            respuesta['menu'] = this.prepararMenu(respuesta);
            respuesta["estudio"] = this.formulario.get('tipoestudio').value;
            respuesta['participacion'] = expediente.enAporte;
            respuesta['fechainivigencia'] = expediente.fechainivigencia;
            respuesta['fechafinvigencia'] = expediente.fechafinvigencia;
            
            this.localStorage.setItem(`detalle`, respuesta).subscribe(
              (resp) => {
                if (registrarAporte === true) {
                  this.router.navigate([`/estudio/participacion`]);
                } else {
                  this.router.navigate(['/estudio']);
                }
              }
            );
          } else {
            Swal.fire({
              title: `Aviso`,
              text: respuesta.error,
              icon: 'error',
              confirmButtonText: 'Aceptar'
            })
          }
        }
      },
      (error) => {
        if (error.status === 200) {
          Swal.fire({
            title: `Código error: ${error.status}`,
            text: `El expediente ${expediente.expediente} contiene una estructura JSON inválido.`,
            icon: 'warning',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        Swal.fire({
          title: `Error: ${error.status}`,
          text: 'Error al consultar el expediente. Intente nuevamente',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      }
    )
  }
  // verDetalle(codigoExpte: string, idExpediente?: string, enAporte?: number, registrarAporte?: boolean) {
  verDetalle(expediente: any, registrarAporte?: boolean) {
    Swal.fire({
      text: 'Consultando ...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
    });
    Swal.showLoading();
    // this.serviceSenace.getDetalleExpediente('M-EIAD-00008-2020').subscribe(
    let url = expediente.url;
    if (!expediente.url) {
      this.serviceSenace.registrarAnexoUId(expediente.expediente, expediente.idExpediente)
        .subscribe(
          (resp) => {
            url = resp.Result.url;
            // url = resp.Result.url.split('/').pop();
            this.leerDetalleExpediente(expediente, registrarAporte, url);
          }, (error) => {
            Swal.fire({
              title: `Aviso`,
              text: 'Error al obtener la UID de la url del expediente',
              icon: 'error'
            })
          }
        )
    }
    else {
      // url = uid.split('/').pop(); // Obtener el UID de la URL
      this.leerDetalleExpediente(expediente, registrarAporte, url);
    }

  }
  exportarResultado(): void {
    if (this.resultado.length === 0) {
      Swal.fire({
        title: 'Aviso',
        text: 'No hay resultados a exportar',
        confirmButtonText: 'Aceptar',
        icon: 'warning'
      });
      return;
    }
    let data: any[] = [];
    this.resultado.forEach(element => {
      data.push({
        "TITULO PROYECTO": element.tituloProyecto,
        "NOMBRE TITULAR": element.titularNombre,
        "UNIDAD PROYECTO": element.unidadProyecto,
        "TIPO ESTUDIO": element.tipoEstudio,
        "ACTIVIDAD": element.actividad,
        "UBICACIÓN": element.ubicacion,
        "EXPEDIENTE": element.expediente,
        "FECHA EXPEDIENTE": element.fechaExpediente,
        "ESTADO": element.estado
      })
    });
    this.serviceSenace.exportAsExcelFile(data, 'consultaCiudadana');
  }

  // Preparar menu modulo
  private prepararMenu(data: any) {
    let menu = {
      datosGenerales: true,
      seguimientoProyecto: true,
      areasEfectivas: false,
      descripcionProyecto: false,
      lineaBase: false,
      participacionCiudadana: false,
      impactoAmbiental: false,
      manejoAmbiental: false,
      valoracionEconomica: false,
      mapaGeneral: false
    };
    if (data.solicitud) {
      for (const keySolicitud in data.solicitud) {
        if (keySolicitud === 'secciones') {
          for (const keySeccion in data.solicitud.secciones) {
            let secciones = data.solicitud.secciones[keySeccion];
            for (const keyCapitulos in secciones) {
              if (keyCapitulos === 'capitulos') {
                let capitulos = secciones['capitulos'];
                for (const keyDatos in capitulos) {
                  let datos = capitulos[keyDatos];
                  for (const keySubDatos in datos['datos']) {

                    /*================================================
                    =            Areas Efectivas            =
                    ================================================*/
                    if (keySubDatos === 'areaEfectivaProyecto') { menu.areasEfectivas = true; menu.mapaGeneral = true; } //[]

                    /*================================================
                    =            Descripcion del Proyecto            =
                    ================================================*/
                    if (keySubDatos === 'estudioPrevioAprobado') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'permisosVigentes') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'componentes') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'empleo') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'insumos') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'usoAgua') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'efluentes') { menu.descripcionProyecto = true; } //[]

                    /*================================================
                    =            Linea Base            =
                    ================================================*/
                    if (keySubDatos === 'clima') { menu.lineaBase = true; }
                    if (keySubDatos === 'estacionesMeteorologicas') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'fuentesAgua') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'estacionesMuestreo') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'aspectoPoblacion') { menu.lineaBase = true; } //[]

                    /*================================================
                    =            Participación Ciudadana            =
                    ================================================*/
                    if (keySubDatos === 'registroActividades') { menu.participacionCiudadana = true; } //[]


                    if (keySubDatos === 'manejoAmbiental' || keySubDatos === 'compromisoSocial' || keySubDatos === 'programaMonitoreo') {  //[]
                      // menu.participacionCiudadana = true; 

                      // let datoManejoAmb = datos['datos']['manejoAmbiental'];
                      let datoManejoAmb = datos['datos'][keySubDatos];

                      for (const keyManejoAmb in datoManejoAmb) {
                        let lectura = datoManejoAmb[keyManejoAmb];
                        for (const keyManejos in lectura) {

                          /*================================================
                          =            Impacto Ambiental            =
                          ================================================*/
                          if (keyManejos === 'medios') { menu.impactoAmbiental = true; } //[]

                          /*================================================
                          =            Manejo Ambiental            =
                          ================================================*/
                          if (keyManejos === 'manejosAmbientales' || keyManejos === 'compromisosSociales' || keyManejos === 'identificacionPunto') { menu.manejoAmbiental = true; } //[]


                        }
                      }
                    }

                    /*================================================
                    =            Valoración Económica            =
                    ================================================*/
                    if (keySubDatos === 'valoracionEconomica') {  //[]
                      menu.valoracionEconomica = true;
                    }

                  }
                }
              }
            }
          }
        }
      }
    }
    return menu;
  }
  // Validaciones
  get validarRuc() {
    return this.formulario.get('ruc').invalid && this.formulario.get('ruc').touched;
  }
  get validarNroExpediente() {
    return this.formulario.get('nroexpediente').invalid && this.formulario.get('nroexpediente').touched;
  }
  private validarFechaRango(fdesde: string, fhasta: string): boolean {
    // const tieneFechas = (fdesde === '' && fhasta !== '');
    const tieneFechas = (fdesde !== '' && fhasta === '') || (fdesde === '' && fhasta !== '');
    if (tieneFechas) {
      Swal.fire({
        title: 'Aviso',
        // text: 'Campo de fecha no válido. Ingrese la fecha inicio.',
        text: 'El rango de fecha no es válido. Por favor verifique los campos.',
        icon: 'warning'
      });
      return false;
    }
    return true;
  }
  private validarFormatoFecha(fdesde: string, fhasta: string): boolean {
    if(fdesde){
      if (!moment(fdesde, 'DD/MM/YYYY', true).isValid()) {
        Swal.fire({
          title: 'Aviso',
          text: 'Las fecha inicio no tiene un formato válido',
          icon: 'warning'
        });
        return false;
      }
    }
    if (fhasta) {
      if (!moment(fhasta, 'DD/MM/YYYY', true).isValid()) {
        Swal.fire({
          title: 'Aviso',
          text: 'Las fecha fin no tiene un formato válido',
          icon: 'warning'
        });
        return false;
      }
    }
    return true;
  }
  private validarFecha(fdesde: string, fhasta: string) {
    if (fdesde && fhasta) {
      const desde = moment(fdesde, 'DD/MM/YYYY').toDate();
      const hasta = moment(fhasta, 'DD/MM/YYYY').toDate();

      const valido = desde <= hasta;
      const fechaMaxHoy = desde <= new Date() && hasta <= new Date();
      if (!valido || !fechaMaxHoy) {
        Swal.fire({
          title: 'Aviso',
          text: !valido ? 'La fecha inicio debe ser menor o igual a la fecha fin' : 'Las fechas ingresadas deben ser menor o igual al día de hoy.',
          icon: 'warning'
        });
        return false;
      }
    }
    return true;
  }

  validarFechaBusqueda(): boolean {    
    this.fechaDesde = '';
    this.fechaHasta = '';

    if (this.fromDate) {
      let df = this.fromDate.day <= 9 ? '0' + this.fromDate.day : this.fromDate.day;
      let mf = this.fromDate.month <= 9 ? '0' + this.fromDate.month : this.fromDate.month;
      this.fechaDesde = `${df}/${mf}/${this.fromDate.year}`;
    }

    if (this.toDate) {
      let dt = this.toDate.day <= 9 ? '0' + this.toDate.day : this.toDate.day;
      let mt = this.toDate.month <= 9 ? '0' + this.toDate.month : this.toDate.month;
      this.fechaHasta = `${dt}/${mt}/${this.toDate.year}`;
    }
    
    if (!this.validarFechaRango(this.fechaDesde, this.fechaHasta)) {
      return false;
    }
    if (!this.validarFormatoFecha(this.fechaDesde, this.fechaHasta)) {
      return false;
    }
    if (!this.validarFecha(this.fechaDesde, this.fechaHasta)) {
      return false;
    }

    return true;
  }
  // Servicios
  getTipoEstudio() {
    this.serviceSenace.getTipoEstudio().subscribe(
      resp => {
        this.dataTipoEstudio = resp;
        this.dataTipoEstudio.unshift({
          TIPOPROYECTO: 0,
          TIPO_PROYECTO: '-- Seleccione --'
        });
      }
    );

  }
  getDepartamento() {
    this.serviceSenace.getUbigeo('departamento').subscribe(
      resp => {

        this.dataProvincia = null;
        this.dataDistrito = null;

        this.formulario.patchValue({
          departamento: 0,
          provincia: 0,
          distrito: 0
        });
        // this.formulario.value.departamento = 0;
        // this.formulario.value.provincia = 0;
        // this.formulario.value.distrito = 0;

        this.dataDepartamento = resp;
        this.dataDepartamento.unshift({
          ID_DEPARTAMENTO: '0',
          NOMBRE: '-- Seleccione --'
        });
      }
    );
  }
  getProvincia() {
    Swal.fire('', 'Cargando provincias ...', 'info');
    Swal.showLoading();
    this.serviceSenace.getUbigeo('provincia', this.formulario.value.departamento).subscribe(
      resp => {
        this.dataDistrito = null;

        this.formulario.patchValue({
          provincia: 0,
          distrito: 0
        })
        this.dataProvincia = resp;
        this.dataProvincia.unshift({
          ID_PROVINCIA: '0',
          NOMBRE: '-- Seleccione --'
        });
        Swal.close();
      }
    );
  }
  getDistrito() {
    Swal.fire('', 'Cargando distritos ...', 'info');
    Swal.showLoading();
    this.serviceSenace.getUbigeo('distrito', this.formulario.value.provincia).subscribe(
      resp => {
        this.formulario.patchValue({
          distrito: 0,
        })
        this.dataDistrito = resp;
        this.dataDistrito.unshift({
          ID_UBIGEO: '0',
          NOMBRE_DISTRITO: '-- Seleccione --'
        });
        Swal.close();
      }
    );
  }
  getEstado() {
    this.serviceSenace.getEstado().subscribe(
      resp => {
        this.dataEstado = resp;
        this.dataEstado.unshift({
          ID_ESTADO_EXP: 0,
          NOMBRE_ESTADO_EXP: '-- Seleccione --'
        });
      }
    );
  }
  getActividad() {
    this.serviceSenace.getActividad().subscribe(
      resp => {
        this.dataActividad = resp;
        this.dataActividad.unshift({
          ID_ACTIVIDAD: 0,
          NOMBRE_ACTIVIDAD: '-- Seleccione --'
        });
      }
    );
  }


}
